import { getFrozenScroll } from '../components/Overlay'

export interface ScrollPosition {
	y: number
	key?: string
	top?: number
}

export function captureScroll(root: HTMLElement): ScrollPosition {
	const items = root.querySelectorAll<HTMLElement>(
		'[data-activity-id], li[data-release-id]',
	)
	const item = Array.from(items).find(
		(element) => element.getBoundingClientRect().bottom > 0,
	)
	return {
		y: getPageScrollY(root),
		key: item?.dataset.activityId ?? item?.dataset.releaseId,
		top: item?.getBoundingClientRect().top,
	}
}

export function restoreScroll(
	root: HTMLElement,
	position: ScrollPosition,
): void {
	const item = position.key
		? Array.from(
				root.querySelectorAll<HTMLElement>(
					'[data-activity-id], li[data-release-id]',
				),
			).find(
				(element) =>
					(element.dataset.activityId ??
						element.dataset.releaseId) === position.key,
			)
		: undefined
	const y =
		item && position.top !== undefined
			? getPageScrollY(root) +
				item.getBoundingClientRect().top -
				position.top
			: position.y
	// Behind an overlay, the page keeps its offset in its own frozen layer.
	const frozenPage = getFrozenPage(root)
	if (frozenPage) {
		const maxY = frozenPage.offsetHeight - window.innerHeight
		frozenPage.style.setProperty(
			'--overlay-frozen-scroll',
			`${Math.max(0, Math.min(y, maxY))}px`,
		)
		return
	}
	window.scrollTo({
		top: Math.max(
			0,
			Math.min(
				y,
				document.documentElement.scrollHeight - window.innerHeight,
			),
		),
		behavior: 'instant',
	})
}

function getPageScrollY(root: HTMLElement): number {
	const frozenPage = getFrozenPage(root)
	return frozenPage ? getFrozenScroll(frozenPage) : window.scrollY
}

function getFrozenPage(root: HTMLElement): HTMLElement | null {
	return root.closest<HTMLElement>('#content.overlay-frozen')
}
